<template>
  <div>
    <b-row>
      <b-col cols="7">

      <b-card-code
          title="Persönliche Angaben"
          class="col-12"
      >
        <b-row class="float-right">
          Fahrer Id: {{edit.DId}}
        </b-row>
        <hr class="mt-2">
        <b-row>

          <b-col
              md="8"
              xl="8"
              class="mb-1"
          >
            <b-form-group
                label="Nachname, Vorname"
            >
              <b-form-input
                  v-model="edit.Contact.Name"
              />
            </b-form-group>
          </b-col>

          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Geburtsdatum"
            >
              <b-form-input
                  v-model="edit.Birthday"
              />
            </b-form-group>
          </b-col>


          <b-col
              md="12"
              xl="12"
              class="mb-1"
          >
            <hr>
          </b-col>

          <b-col
              md="3"
              xl="3"
              class="mb-1"
          >
            <b-form-group
                label="Kürzl."
            >
              <b-form-input
                  v-model="edit.DriverShortName"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="3"
              xl="3"
              class="mb-1"
          >
            <b-form-group
                label="Fahrzeug"
            >
              <b-form-select
                  id="perPageSelect"
                  v-model="edit.DefaultVehicle"
                  :options="vehicleList"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="3"
              xl="3"
              class="mb-1"
          >
            <b-form-group
                label="Pushover"
            >
              <b-form-select
                  id="perPageSelect"
                  v-model="edit.PushoverId"
                  :options="pushoverList"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="3"
              xl="3"
              class="mb-1"
          >
            <b-form-group
                label="Pushover (Pickups)"
            >
              <b-form-checkbox
                  v-model="edit.PushoverPickups"
                  name="is-vertical-menu-collapsed"
                  class="mt-1"
                  switch
                  inline
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-code>

      <b-card-code
          title="Adressinformationen"
          class="col-12"
      >

        <b-row>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Straße Nr."
            >
              <b-form-input
                  v-model="edit.Address.Street"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Postleitzahl"
            >
              <b-form-input
                  v-model="edit.Address.ZipCode"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Ort"
            >
              <b-form-input
                  v-model="edit.Address.Location"
              />
            </b-form-group>
          </b-col>
        </b-row>

      </b-card-code>

      <b-card-code
          title="Kontaktinformationen"
          class="col-12"
      >

        <b-row>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Telefon 1"
            >
              <b-form-input
                  v-model="edit.Contact.Phone"
              />
            </b-form-group>
          </b-col>

          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Telefon 2"
            >
              <b-form-input
                  v-model="edit.Contact.Phone2"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="E-Mail"
            >
              <b-form-input
                  v-model="edit.Contact.Email"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-code>

      <b-card-code
          title="Sonstige Informationen"
          class="col-12"
      >

        <b-row>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Eintritt"
            >
              <b-input-group>
                <b-form-input
                    v-model="edit.EntryDate"
                    type="text"
                    placeholder="DD.MM.YY"
                    autocomplete="off"
                    show-decade-nav
                />
                <b-input-group-append>
                  <b-form-datepicker
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      button-only
                      :start-weekday="1"
                      locale="de-DE"
                      @context="onPickEntryDate"
                  />
                </b-input-group-append>
              </b-input-group>

            </b-form-group>
          </b-col>

          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Austritt"
            >
              <b-input-group>
                <b-form-input
                    v-model="edit.LeavingDate"
                    type="text"
                    placeholder="DD.MM.YY"
                    autocomplete="off"
                    show-decade-nav
                />
                <b-input-group-append>
                  <b-form-datepicker
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      button-only
                      :start-weekday="1"
                      locale="de-DE"
                      @context="onPickLeaveDate"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="P-Schein bis"
            >
              <b-input-group>
                <b-form-input
                    v-model="edit.PassengerTransportTicket"
                    type="text"
                    placeholder="DD.MM.YY"
                    autocomplete="off"
                    show-decade-nav
                />
                <b-input-group-append>
                  <b-form-datepicker
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      button-only
                      :start-weekday="1"
                      locale="de-DE"
                      @context="onPickPassengerTransportTicketDate"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>

          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="SV-Nummer (Für Lohnschein)"
            >
              <b-input-group>
                <b-form-input
                    v-model="edit.SvNumber"
                    type="text"
                    placeholder=""
                    show-decade-nav
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-code>

        <b-card-code
            title="Farbe"
            class="col-12"
        >
          <b-row>
          <b-col
              md="6"
              xl="6"
              class="mb-1"
          >
            <b-form-group
                label="Hintergrundfarbe"
            >
              <b-input-group>
                <b-form-input
                    v-model="edit.Color1"
                    type="text"
                    placeholder="#FFFFFF"
                    autocomplete="off"
                    show-decade-nav
                />
                <b-input-group-append>

                  <verte picker="square" model="hex" v-model="edit.Color1">
                    <svg viewBox="0 0 24 24">
                      <path d="M0 20h24v4H0z"/>
                      <path style="fill: #000" d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"/>
                    </svg>
                  </verte>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col
              md="6"
              xl="6"
              class="mb-1"
          >
            <b-form-group
                label="Textfarbe"
            >

              <b-input-group>
                <b-form-input
                    v-model="edit.Color2"
                    type="text"
                    placeholder="#FFFFFF"
                    autocomplete="off"
                    show-decade-nav
                />
                <b-input-group-append>

                  <verte picker="square" model="hex" v-model="edit.Color2">
                    <svg viewBox="0 0 24 24">
                      <path d="M0 20h24v4H0z"/>
                      <path style="fill: #000" d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"/>
                    </svg>
                  </verte>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          </b-row>
        </b-card-code>
      </b-col>

      <b-col cols="5">
        <b-card-code
            title="Downloads"
            class="col-12"
        >
          <b-col
              md="12"
              xl="12"
          >
            <b-table
                striped
                hover
                responsive
                :items="payrollList"
                :fields="fields"
            >
              <template #cell(action)="data">

                <b-button-group>
                  <b-dropdown
                      class="btn-sm"
                      variant="flat-success"
                      right
                      split
                      text="Download"
                      @click="DownloadFile(data.item.FileId)"
                  >
                    <b-dropdown-item
                        @click="DeleteFile(data.item.FileId)">Entfernen</b-dropdown-item>
                    <b-dropdown-item
                        @click="CreateSevDeskPayrollVoucher(data.item.FileId)">Sevdesk Voucher erstellen</b-dropdown-item>
                  </b-dropdown>
                </b-button-group>

              </template>
            </b-table>
          </b-col>
        </b-card-code>
      </b-col>
      <b-col cols="12">
        <b-card-code
            class="col-12"
        >
          <b-row>
            <b-col
                md="6"
                xl="6"
                v-if="HasRights(10)"
            >
              <b-button
                  class="btn-info btn-block"
                  @click="OpenInvoice(edit.DId)"
              >
                Fahrerabrechnung
              </b-button>
            </b-col>
            <b-col
                md="6"
                xl="6"
                v-if="HasRights(10)"
            >
              <b-button class="btn-success btn-block" @click="Save">Speichern</b-button>
            </b-col>
          </b-row>
        </b-card-code>
      </b-col>


    </b-row>

  </div>
</template>

<script>

import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem, BFormDatepicker, BFormFile, BTabs, BTab, BCard, BCardTitle, BCardSubTitle, BCardBody, BCardHeader, BFormCheckbox,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Verte from 'verte'
import BCardCode from '@core/components/b-card-code'
import Cleave from 'vue-cleave-component'

export default {
  name: 'DriverEdit',
  components: {
    BFormCheckbox,
    Cleave,
    BCardCode,
    BCardHeader,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    Verte,
    BTab,
    BTabs,
    BFormFile,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormDatepicker,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
  },
  props: {
    series: {
      type: Array,
      default: null,
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Fahrer'
    })
    this.LoadVehicleList()
    this.LoadPushoverList()
    this.LoadDriver();
    this.LoadFiles();
  },
  data() {
    return {
      options: {
        Time2Label: 'Abflug',
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
      },
      pushoverList: [],
      vehicleList: [],
      payrollList: [],

      fields: [
        {
          key: 'name',
          label: 'Name',
        },
        {
          key: 'action',
          label: 'Aktion',
        },
      ],

      edit: {
        DId: 0,
        DriverShortName: '',
        Contact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: '',
        },
        Address: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: '',
        },
        BankDetails: {
          AccountOwner: '',
          Iban: '',
          Bic: '',
        },
        DefaultVehicle: 0,
        Birthday: '',
        EntryDate: '',
        LeavingDate: '',
        PushoverId: 0,
        PassengerTransportTicket: '',
        HourlyWages: 0.00,
        HourlyAccount: 0.00,
        Color1: '',
        Color2: '',
        SvNumber: '',
        PushoverPickups: false,
      }

    }
  },
  methods: {
    HasRights(id) {
      return this.$store.state.user.Rights.includes('R'+id);
    },
    OpenInvoice(did) {
      this.$router.push({ name: 'DriverInvoice', params: { driver: did } })
    },
    LoadPushoverList() {
      this.pushoverList.push({
        value: 0,
        text: "Kein Account"
      })
      this.$http.get(`/pushover/list`)
          .then(resp => {
            resp.data.list.forEach(p => {
              console.log(p)
              this.pushoverList.push({
                value: p.IdentId,
                text: p.Name
              })
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadVehicleList() {
      this.vehicleList.push({
        value: 0,
        text: "Keins"
      })
      this.$http.get(`/vehicle/list`)
          .then(resp => {
            resp.data.forEach(p => {
              this.vehicleList.push({
                value: p.VId,
                text: p.NumberPlate
              })
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadFiles() {
      this.$http.get(`/driver/get/payroll/${this.$route.params.driver}`)
          .then(resp => {
            if(resp.data.success) {
              resp.data.list.forEach(i => {
                this.payrollList.push({
                  name: i.Name,
                  FileId: i.FileId,
                  action: '',
                })
              })
            }
          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
    async DownloadFile(fileId) {
      this.$http.get(this.$http.defaults.baseURL + 'files/get/' + fileId + "/" + this.$cookies.get("jwt"), {responseType: 'blob'})
          .then(resp => {
            window.open(URL.createObjectURL(resp.data));

          })
          .catch(err => {
            console.error(err)
          })

    },
    async CreateSevDeskPayrollVoucher(fileId) {
      this.$http.post('taxoffice/create/payroll/sevdeskvoucher', JSON.stringify({
        FileId: fileId,
        DriverId: this.edit.DId,
      }))
          .then(resp => {
            if (resp.data.success) {
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Info',
                      icon: 'CheckIcon',
                      text: 'OK.',
                      variant: 'success',
                    },
                  },
                  {
                    timeout: 5000,
                  })

              window.open("https://my.sevdesk.de/ex/VOU/edit/type/C/id/" + resp.data.sevDeskVoucherId);

            } else {
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Fehler',
                      icon: 'CheckIcon',
                      text: resp.data.message,
                      variant: 'danger',
                    },
                  },
                  {
                    timeout: 5000,
                  })
            }
          })
          .catch(err => {
            this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Fehler',
                    icon: 'CheckIcon',
                    text: 'Es ist ein Fehler aufgetreten',
                    variant: 'danger',
                  },
                },
                {
                  timeout: 5000,
                })
            console.error(err)
          })
    },
    async DeleteFile(fileId) {
      this.$http.delete(this.$http.defaults.baseURL + 'files/delete/' + fileId)
          .then(resp => {
            this.payrollList = this.payrollList.filter(item => item.FileId !== fileId);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Info',
                icon: 'CheckIcon',
                text: 'Eintrag und File wurden gerlöscht.',
                variant: 'success',
              },
            })
          })
          .catch(err => {
            console.error(err)
          })

    },
    LoadDriver() {
      console.log(this.$route.params.driver)
      this.$http.get(`/driver/get/${this.$route.params.driver}`)
          .then(resp => {
            if(resp.data.success) {

              this.edit = resp.data.driver;
              if(!resp.data.driver.Birthday) {
                resp.data.driver.Birthday = '';
              }
              if (resp.data.driver.EntryDate != null) {
                this.edit.EntryDate = `${new Date(resp.data.driver.EntryDate).toLocaleString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    },
                )}`
              }

              if (resp.data.driver.LeavingDate != null) {
                this.edit.LeavingDate = `${new Date(resp.data.driver.LeavingDate).toLocaleString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    },
                )}`
              } else
                this.edit.LeavingDate = ''


              if (resp.data.driver.Birthday != null) {
                this.edit.Birthday = `${new Date(resp.data.driver.Birthday).toLocaleString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    },
                )}`
              } else
                this.edit.LeavingDate = ''

              if (resp.data.driver.PassengerTransportTicket != null) {
                this.edit.PassengerTransportTicket = `${new Date(resp.data.driver.PassengerTransportTicket).toLocaleString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    },
                )}`
              }
            }
            else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: "Fahrer kann nicht geladen werden.",
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })

    },
    Save() {
      let editDriver = Object.assign({}, this.edit)
      editDriver.CallId = this.$store.state.user.callCount + '-' + new Date().getTime()
      editDriver.LeavingDate != '' ? editDriver.LeavingDate = new Date(this.edit.LeavingDate.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : delete editDriver.LeavingDate
      editDriver.EntryDate != '' ? editDriver.EntryDate = new Date(this.edit.EntryDate.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : delete editDriver.EntryDate
      editDriver.PassengerTransportTicket != '' ? editDriver.PassengerTransportTicket = new Date(this.edit.PassengerTransportTicket.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : delete editDriver.PassengerTransportTicket
      editDriver.Birthday != '' ? editDriver.Birthday = new Date(this.edit.Birthday.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : delete editDriver.Birthday
      if(!this.edit.SvNumber || this.edit.SvNumber == "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Fehler',
            icon: 'CheckIcon',
            text: "SV-Nummer fehlt",
            variant: 'danger',
          },
        })
      } else {
        this.$http.post('driver/edit', JSON.stringify(editDriver))
            .then(resp => {
              if (resp.data.success) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Info',
                    icon: 'CheckIcon',
                    text: 'Fahrer wurde gespeichert.',
                    variant: 'success',
                  },
                })
                this.LoadList()

                this.$bvModal.hide('modal-edit-driver')
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Fehler',
                    icon: 'CheckIcon',
                    text: resp.data.message,
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
      }

    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          },
      )}`
    },
    onPickEntryDate(ctx) {
      console.log(ctx.activeFormatted)
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.edit.EntryDate = ctx.activeFormatted

      }
    },
    onPickLeaveDate(ctx) {
      if (ctx.selectedDate) {
        this.edit.LeavingDate = ctx.activeFormatted
      }
    },
    onPickPassengerTransportTicketDate(ctx) {
      if (ctx.selectedDate) {
        this.edit.PassengerTransportTicket = ctx.activeFormatted
      }
    },
  }
}

</script>
